import { RegistryManager } from "./registerManager";

export function asSmartDBEntity() {
    return function (target: any) {
        RegistryManager.register(target.className(), target, 'smartDBEntities');
    };
}
